/**
 * KLG Quotes API
 *
 * Contact: xxx@kaplan.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface PriceListsFilterApiDto {
  area?: PriceListsFilterApiDto.AreaEnum;
  year?: number;
  market?: string;
  company?: PriceListsFilterApiDto.CompanyEnum;
}
export namespace PriceListsFilterApiDto {
  export const AreaEnum = {
    EU: 'EU',
    ROW: 'ROW',
    ONLINE: 'ONLINE',
  } as const;
  export type AreaEnum = (typeof AreaEnum)[keyof typeof AreaEnum];
  export const CompanyEnum = {
    KIL: 'KIL',
    PL: 'PL',
    ALP: 'ALP',
    ESL: 'ESL',
  } as const;
  export type CompanyEnum = (typeof CompanyEnum)[keyof typeof CompanyEnum];
}
